module.exports = __webpack_public_path__ + "static/media/Thankyou.ce8b49bc.gif";